export default {"src":"/_next/static/media/markets.7421d0a6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};